// extracted by mini-css-extract-plugin
module.exports = {"lia-btn":"HeroButton_lia-btn__1HNFu"};